import React, { useEffect, useState } from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { useAppApi } from "@/App";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

export default function PocketsList() {
    const apiUrl = url_reverse("api:pockets:list");
    const { apiData } = useAppApi(apiUrl);
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState();
    const { hash } = useLocation();

    const handleTabChange = (tab) => {
        history.pushState(null, null, tab);
        setActiveTab(tab);
    };

    useEffect(() => {
        if (!hash && apiData) {
            setActiveTab(`#group_${apiData.data[0]?.group.id}`);
        }
    }, [apiData]);

    useEffect(() => {
        setActiveTab(hash);
    }, [hash]);

    return (
        <DefaultLayout>
            {apiData && (
                <Row>
                    <Tab.Container id="pocket-group-tab" activeKey={activeTab} onSelect={handleTabChange}>
                        <Col md={3}>
                            <div className="sticky-top dmg-sidebar">
                                <Nav variant="pills" className="card flex-column">
                                    {apiData?.data?.map((item) => (
                                        <Nav.Link
                                            key={`pocket_group_${item.group.id}`}
                                            eventKey={`#group_${item.group.id}`}
                                        >
                                            {item.group.name}
                                        </Nav.Link>
                                    ))}
                                    <Nav.Link as={Link} to={url_reverse("admin:landing_ct:landings")}>
                                        {t("Конструктор лендингов")}
                                    </Nav.Link>
                                </Nav>
                            </div>
                        </Col>
                        <Col md={9}>
                            <Card>
                                <Card.Header>{t("Карманы")}</Card.Header>
                                <Tab.Content>
                                    {apiData?.data &&
                                        apiData.data.map((item) => (
                                            <Tab.Pane
                                                key={`tab_pocket_group_${item.group.id}`}
                                                eventKey={`#group_${item.group.id}`}
                                            >
                                                <Card.Body>
                                                    {item.pockets.length === 0 && (
                                                        <b>{t("В этой группе нет карманов")}</b>
                                                    )}
                                                    {item.pockets.length > 0 &&
                                                        item.pockets.map((pocket) => (
                                                            <Link
                                                                className="d-block"
                                                                key={pocket.slug}
                                                                to={url_reverse("admin:pockets:items", {
                                                                    slug: pocket.slug,
                                                                })}
                                                            >
                                                                {pocket.name}
                                                            </Link>
                                                        ))}
                                                </Card.Body>
                                            </Tab.Pane>
                                        ))}
                                </Tab.Content>
                            </Card>
                        </Col>
                    </Tab.Container>
                </Row>
            )}
        </DefaultLayout>
    );
}
